'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Fares.Common', 'AVRO.Common.GridPanel'];
module.exports = angular.module('AVRO.SystemStatus.InterfaceStatus', dependencies).controller('SystemStatusInterfaceStatusController', require('./controllers/SystemStatusInterfaceStatusController')).directive('rmSystemStatusInterfaceStatus', require('./directives/SystemStatusInterfaceStatusDirective'));